import { RolepermissionService } from './../../../pages/RolePermission/rolepermission.service';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Menu } from './menu.model';

@Injectable()
export class MenuService {

  constructor(private location: Location,
    public rolepermissionService: RolepermissionService) { }


  public getVerticalMenuItems(): Promise<Array<Menu>> {
    return new Promise<Array<Menu>>((resolve, reject) => {
      const currentUserRole = localStorage.getItem('currentUserRole');
      if (!currentUserRole) {
        resolve([]);
        return;
      }
      try {
        const sessionUser = JSON.parse(localStorage.getItem('sessionUser'));
        const role = sessionUser?.roles?.filter((item: any) => item.name === currentUserRole)[0];
        if (!role) {
          resolve([]);
          return;
        }
        const currentUserRoleId = role.id;
        const menuArray: Menu[] = [];
        this.rolepermissionService.getMenuItemsByRoleId(currentUserRoleId).subscribe(result => {
          if (result) {
            const orderedResult = result.sort((a, b) => a.sortOrder < b.sortOrder ? -1 : a.sortOrder === b.sortOrder ? 0 : 1);
            for (let index = 0; index < orderedResult.length; index++) {
              menuArray.push(new Menu(
                orderedResult[index].id,
                orderedResult[index].title,
                orderedResult[index].routerLink,
                orderedResult[index].href,
                orderedResult[index].icon,
                orderedResult[index].target,
                orderedResult[index].hasSubMenu,
                orderedResult[index].parentId));
            }
            resolve(menuArray);
          } else {
            reject();
          }
        });
      } catch {
        resolve([]);
      }
    });
  }



  public getHorizontalMenuItems(): Array<Menu> {
    let currentUserRole = localStorage.getItem('currentUserRole');
    let menuArray = [];
    return menuArray;
  }

  public expandActiveSubMenu(menu: Array<Menu>) {
    if (!menu || menu.length === 0) { return; }
    const url = this.location.path();
    const routerLink = url;
    const activeMenuItem = menu.filter(item => item.routerLink === routerLink)[0];
    if (!activeMenuItem) { return; }
    let menuItem = activeMenuItem;
    while (menuItem.parentId != null) {
      const parentMenuItem = menu.filter(item => item.id == menuItem.parentId)[0];
      if (!parentMenuItem) { break; }
      menuItem = parentMenuItem;
      this.toggleMenuItem(menuItem.id);
    }
  }

  public toggleMenuItem(menuId) {
    const menuItem = document.getElementById('menu-item-' + menuId);
    const subMenu = document.getElementById('sub-menu-' + menuId);
    if (subMenu && menuItem) {
      if (subMenu.classList.contains('show')) {
        subMenu.classList.remove('show');
        menuItem.classList.remove('expanded');
      } else {
        subMenu.classList.add('show');
        menuItem.classList.add('expanded');
      }
    }
  }

  public closeOtherSubMenus(menu: Array<Menu>, menuId) {
    const currentMenuItem = menu.filter(item => item.id == menuId)[0];
    if (!currentMenuItem || (currentMenuItem.parentId != null) || currentMenuItem.target) {
      return;
    }
    menu.forEach(item => {
      if (item.id != menuId) {
        const subMenu = document.getElementById('sub-menu-' + item.id);
        const menuItem = document.getElementById('menu-item-' + item.id);
        if (subMenu && menuItem && subMenu.classList.contains('show')) {
          subMenu.classList.remove('show');
          menuItem.classList.remove('expanded');
        }
      }
    });
  }

  public closeAllSubMenus() {
    const menu = document.getElementById('vertical-menu');
    if (!menu?.children[0]) { return; }
    const container = menu.children[0];
    for (let i = 0; i < container.children.length; i++) {
      const child = container.children[i];
      const first = child?.children[0];
      const second = child?.children[1];
      if (first?.classList?.contains('expanded') && second) {
        first.classList.remove('expanded');
        second.classList.remove('show');
      }
    }
  }


}

// let menuForDatabase = [];

//     menuForDatabase = [
//       new MenuForDatabase(1, 'Exams', null, null, 'computer', null, true, 0, 1, null),
//       new MenuForDatabase(2, 'Surveys', null, null, 'computer', null, true, 0, 2, null),
//       new MenuForDatabase(3, 'Evaluations', null, null, 'computer', null, true, 0, 3, null),
//       new MenuForDatabase(4, 'School bag', null, null, 'computer', null, true, 0, 4, null),
//       new MenuForDatabase(5, 'Attendance', null, null, 'computer', null, true, 0, 5, null),

//       new MenuForDatabase(6, 'Exams', '/exams', null, 'account_balance', null, false, 1, 1, 'exams'),
//       new MenuForDatabase(7, 'Assign management', 'exams/assign-management', null, 'account_balance', null, false, 1, 2, 'assign-management'),
//       new MenuForDatabase(8, 'Published exams', 'exams/published-exams', null, 'card_membership', null, false, 1, 3, 'published-exams'),
//       new MenuForDatabase(9, 'Published exams correction', 'exams/published-exams-correction', null, 'card_membership', null, false, 1, 4, 'published-exams-correction'),
//       new MenuForDatabase(10, 'Mock exams', '/mocks', null, 'poll', null, false, 1, 5, 'mocks'),
//       new MenuForDatabase(11, 'Exam index', 'exams/exam-index', null, 'summarize', null, false, 1, 6, 'exam-index'),
//       new MenuForDatabase(12, 'Subject index', 'exams/subject-index', null, 'summarize', null, false, 1, 7, 'subject-index'),
//       new MenuForDatabase(13, 'Exams and quizzes', 'exams/student-exams', null, 'card_membership', null, false, 1, 8, 'student-exams'),
//       new MenuForDatabase(14, 'Mock exams', 'mocks/student-mocks-exams', null, 'poll', null, false, 1, 9, 'student-mocks-exams'),

//       new MenuForDatabase(15, 'Surveys', '/surveys', null, 'poll', null, false, 2, 1, 'surveys'),
//       new MenuForDatabase(16, 'Assign management', 'surveys/assign-management', null, 'account_balance', null, false, 2, 2, 'assign-management'),
//       new MenuForDatabase(17, 'Assigned surveys', 'surveys/assigned-surveys', null, 'poll', null, false, 2, 3, 'assigned-surveys'),
//       new MenuForDatabase(18, 'Published surveys', 'surveys/published-surveys', null, 'poll', null, false, 2, 4, 'published-surveys'),

//       new MenuForDatabase(19, 'Evaluations', '/evaluations', null, 'poll', null, false, 3, 1, 'evaluations'),
//       new MenuForDatabase(20, 'Assign management', 'evaluations/assign-management', null, 'account_balance', null, false, 3, 2, 'assign-management'),
//       new MenuForDatabase(21, 'Published evaluations', 'evaluations/published-evaluations', null, 'poll', null, false, 3, 3, 'published-evaluations'),
//       new MenuForDatabase(22, 'Students evaluations', 'evaluations/evaluations-class-subsubject', null, 'rule', null, false, 3, 4, 'evaluations-class-subsubject'),
//       new MenuForDatabase(23, 'Targeted evaluations', 'evaluations/targeted-evaluations', null, 'poll', null, false, 3, 5, 'targeted-evaluations'),
//       new MenuForDatabase(24, 'Assigned evaluations', 'evaluations/assigned-evaluations', null, 'poll', null, false, 3, 6, 'assigned-evaluations'),

//       new MenuForDatabase(25, 'School bag', 'schoolBags/school-bag', null, 'business_center', null, false, 4, 1, 'school-bag'),

//       new MenuForDatabase(26, 'Daily attendance', 'dailyAttendance/daily-attendance', null, 'calendar_month', null, false, 5, 1, 'daily-attendance'),

//     ]